import React, { useEffect, useState } from 'react';
import { styled } from 'linaria/react';
import PlayIcon from '../../ui/icons/PlayIcon';

const YOUTUBE_ID = /^[A-Za-z0-9_-]{11}$/;
const YOUTUBE_URL = /(?:youtu\.be\/|youtube(?:-nocookie)?\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/|live\/|v\/))([A-Za-z0-9_-]{11})/;

//ACCEPTS A PLAIN YOUTUBE ID OR A FULL YOUTUBE LINK, RETURNS NULL IF NO ID FOUND
export const getYoutubeId = value => {
  if (!value) return null;
  const trimmed = value.trim();
  if (YOUTUBE_ID.test(trimmed)) return trimmed;
  const match = trimmed.match(YOUTUBE_URL);
  return match ? match[1] : null;
};

//YOUTUBE ID FROM THE data-youtube CUSTOM FIELD
export const getYoutubeVideo = customData => {
  const field =
    customData && customData.filter(item => item.key === 'data-youtube')[0];
  return field ? getYoutubeId(field.stringValue) : null;
};

export const youtubeThumb = id =>
  `https://img.youtube.com/vi/${id}/hqdefault.jpg`;

const SlideWrapper = styled('div')`
  position: relative;
  padding-bottom: 100%;
  .video-frame {
    position: absolute;
    top: 50%;
    left: 0;
    width: 100%;
    padding-bottom: 56.25%;
    transform: translateY(-50%);
    background: black;
  }
  img,
  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 0;
  }
  img {
    object-fit: cover;
  }
  button {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    padding: 0;
    border: 0;
    background: transparent;
    cursor: pointer;
    &:focus {
      outline: none;
    }
  }
  .play {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 4.5rem;
    height: 4.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    transform: translate(-50%, -50%);
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.6);
    color: white;
    font-size: 1.8rem;
    transition: background 0.2s;
    svg {
      margin-left: 0.3rem;
    }
  }
  button:hover .play {
    background: rgba(0, 0, 0, 0.8);
  }
`;

//SHOWS THE THUMBNAIL UNTIL CLICKED, SO YOUTUBE IS ONLY LOADED ON DEMAND
//AND THE IFRAME DOES NOT CATCH SWIPES BEFORE THE VIDEO IS STARTED
export const YoutubeSlide = ({ id, active }) => {
  const [playing, setPlaying] = useState(false);

  //STOP THE VIDEO WHEN THE SLIDER MOVES AWAY FROM IT
  useEffect(() => {
    if (!active) setPlaying(false);
  }, [active]);

  //A SWIPE ENDS WITH A CLICK AFTER THE SLIDE HAS CHANGED, IGNORE IT
  const play = () => {
    if (active) setPlaying(true);
  };

  return (
    <SlideWrapper>
      <div className="video-frame">
        {playing ? (
          <iframe
            title={id}
            src={`https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0`}
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        ) : (
          <button onClick={play} aria-label="Play video">
            <img src={youtubeThumb(id)} alt="" loading="lazy" />
            <span className="play">
              <PlayIcon />
            </span>
          </button>
        )}
      </div>
    </SlideWrapper>
  );
};
